module.exports = __webpack_public_path__ + "img/lrc-space.57ad7547.png";